import {
  memo,
  type FC,
} from 'react';

export const TournamentThead: FC = memo(() => {
  return (
    <thead>
      <tr>
        <th>&#35;</th>
        <th>Player</th>
        <th>Score</th>
        <th>Award</th>
      </tr>
    </thead>
  );
});